// Live beat state published from inside the Canvas (useBeat) so DOM overlays —
// the ?beat=1 dev HUD — can read the exact same free-running grid the world
// visuals and the residents' feet lock to. Mutated each frame; never triggers
// React renders (read it from your own rAF/interval).
export const beatBridge = { phase: 0, bpm: 92, energy: 0.5, t: 0 };
